/* eslint-disable */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Exactly } from './utils'

export type OperationWithAxiosResponse = <T extends Exactly<Request, T>>(request: T) => Promise<AxiosResponse<Response>>
export const operationWithAxiosResponse = <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<AxiosResponse<Response>> => {
  return axios.request({
    url: `/passkey/state`,
    // @ts-ignore for sm-axios
    urlTemplate: '/passkey/state',
    method: 'POST',
    headers: request.headers,
    data: request.body,
  })
}

/**
 * Adds passkey state information for the user
 */
export type Operation = <T extends Exactly<Request, T>>(request: T) => Promise<Response>
export const operation = async <T extends Exactly<Request, T>>(axios: AxiosInstance, request: T): Promise<Response> => {
  return (await operationWithAxiosResponse(axios, request)).data
}

export interface Request {
  headers?: {
    'x-sm-trace-token'?: string
  }
  body: {
    /**
     * The token of the user to add the passkey state for.
     */
    token: string
    /**
     * The passkey state used for step up.
     */
    stateId: string
    /**
     * The passkey this step up authorises an action on (e.g. delete). Stored with the state so the action can be checked against the same passkey.
     */
    passkeyId?: string
  }
}

export interface Response {
  passkeyState: string
}

